module.exports = __webpack_public_path__ + "tb-wireframe2.jpg?1a92c487aaaca8af23546fb03fc7053e";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/tb-wireframe2.jpg
// module id = 241
// module chunks = 0